import Button from "../../../components/Comon/Button/Button";
import VideoPlayer from "../../../components/Survey/VideoPlayer/VideoPlayer";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

export default function WellnessSurveyThankYouScreen({
                                                         settingsData,
                                                         clinicData,
                                                         themeColor,
                                                         handleThankYouNext = () => {},
                                                     })
{
    const { i18n } = useTranslation();
    const [videoSize, setVideoSize] = useState({ width: 600, height: 405 });
    const adjustVideoSize = () => {
        if (window.screen.width < 641) {
            setVideoSize({
                width: 297,
                height: 200,
            });
        } else {
            setVideoSize({
                width: 600,
                height: 405,
            });
        }
    };
    useEffect(() => {
        adjustVideoSize();

        function handleResize() {
            adjustVideoSize();
        }

        window.addEventListener("resize", handleResize);
    }, []);

    return <div
        style={{
            width:'100%',
            display:'grid',
            gridTemplateColumns:settingsData?.thankYouVideoLink ? '1fr 1fr' : '1fr',
            alignItems:'center',
            justifyContent:'center',
            gap:'50px',
        }}
    >
        <div style={{display:'flex',justifyContent:'center',alignItems:'center', flexDirection:'column'}}>
            <div className={"helloDiv"} style={{ borderColor: themeColor, width:'fit-content', textAlign:'center' }}>{settingsData?.thankYouSectionTitle}</div>
            <div className={"headline"}>{settingsData?.thankYouTitle}</div>
            <p style={{ margin: 0, textAlign:'center' }} className="text">
                {settingsData?.thankYouDescription}
            </p>
        </div>


        <div>
            {settingsData?.thankYouVideoLink &&
                <div style={{marginTop:'30px'}}>
                    <VideoPlayer
                        url={settingsData?.thankYouVideoLink}
                        themeColor={themeColor}
                        videoSize={videoSize}
                        id="SurveyHomePage"
                    />
                </div>
            }
        </div>

    </div>
}
